module.exports = __webpack_public_path__ + "static/media/normal.06570911.svg";